import { Box } from "@material-ui/core"
import React, { FC } from "react"
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import "./index.css";

interface HeadTableProps {
    title: string,
    sort?: (direct: string, field: string) => void
    filterHandle?: (title: string) => void
}

const HeadTable: FC<HeadTableProps> = ({ title, sort, filterHandle }) => {
    return (
        <Box display="flex" justifyContent="space-between" alignItems="center"  >
            <Box
                onClick={filterHandle ? () => filterHandle(title) : undefined}
                width="10em"
                height="50px"
                display="flex"
                className={filterHandle ? "title-dropdown" : ''}
                alignItems="center">
                <span className="column-title base-color"> {title} </span>
            </Box>
            {sort && <div className="arrow-wrapper">
                <ArrowDropUpIcon className="arrow-focus arrow-up" onClick={() => sort("asc", title)} />
                <ArrowDropDownIcon className="arrow-focus arrow-down" onClick={() => sort("desc", title)} />
            </div>}
        </Box>
    )
}

export default HeadTable
